import { NAV_BAR_HEIGHT } from 'HubStyleTokens/sizes';
let defaultNavHeight = null;
export const setDefaultNavHeight = navHeight => {
  defaultNavHeight = navHeight;
};
export const getDefaultNavHeight = () => {
  return defaultNavHeight || parseInt(NAV_BAR_HEIGHT, 10);
};